// @flow

import { Panel, PanelBar, PanelButtonBar, PanelHeader } from '../../../element/Panel';
import { Textarea } from '../../../element/Textarea';
import { Notice } from "../../../element/Notice";

import type { BbServer } from '../../../../api/type.srv';
import type { EditorModal } from '../../../common/Editor';

type UserSshKeyEditorProps = {
    +editor: EditorModal<string, null, BbServer>,
}

export const UserSshKeyEditor = ({ editor }: UserSshKeyEditorProps): React$Node => {
    const { value, setValue } = editor;
    return (
        <Panel>
            <PanelHeader title='SSH Key'/>
            <PanelBar>
                <Textarea
                    label='SSH Public Key'
                    rows={5}
                    spellCheck={false}
                    className='break-all w-full max-w-3xl'
                    value={value || ''}
                    helperText='Paste your public key(s) in OpenSSH format, e.g. ssh-rsa abcdef123123...'
                    onChange={setValue}
                    errorText={editor.errors}
                />
                {editor.errors != null
                    ? <Notice type={'warning'} icon='warning-fill'>
                        <p>SSH keys must be entered in OpenSSH format.</p>
                        <p>
                            If you're using PuTTYgen to create keys, make sure
                            to use the value labelled "Public key for pasting
                            into OpenSSH authorized_keys file".
                        </p>
                    </Notice>
                    : null
                }
            </PanelBar>
            <PanelButtonBar
                cacheStatus={editor.messages?.status}
                primaryButton={{onClick: editor.status === 'edit' ? editor.onSave : null}}
                cancel={editor.status === 'edit' ? editor.onCancel : null}
            />
        </Panel>

    );
};